import { FC, memo } from 'react'
import { Box } from '@chakra-ui/react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const BlackboardChartOutline = createIcon({
  displayName: 'BlackboardChartOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0 0h24v24h-24v-24Z"></path>
        <line x1="22" x2="2" y1="3" y2="3" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"></line>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M21 3v11.882c0 1.17-1.007 2.118-2.25 2.118h-13.5c-1.243 0-2.25-.948-2.25-2.118v-11.882"
        ></path>
        <line x1="13" x2="15" y1="17" y2="21" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"></line>
        <line x1="11" x2="9" y1="17" y2="21" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"></line>
        <polyline
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          points="16,8 12.667,11.333 10.667,9.333 8,12"
        ></polyline>
      </g>
    </>
  ),
})

const BlackboardChartTwoTone = createIcon({
  displayName: 'BlackboardChartTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" fill="none">
        <Box
          as="line"
          x1="22"
          x2="2"
          y1="3"
          y2="3"
          stroke="twoToneStrokeColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></Box>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M21 3v11.882c0 1.17-1.007 2.118-2.25 2.118h-13.5c-1.243 0-2.25-.948-2.25-2.118v-11.882"
        ></Box>
        <Box
          as="line"
          x1="13"
          x2="15"
          y1="17"
          y2="21"
          stroke="twoToneStrokeColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></Box>
        <Box
          as="line"
          x1="11"
          x2="9"
          y1="17"
          y2="21"
          stroke="twoToneStrokeColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></Box>
        <Box
          as="polyline"
          stroke="twoToneStrokeColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          points="16,8 12.667,11.333 10.667,9.333 8,12"
        ></Box>
      </Box>
    </>
  ),
})

const BlackboardChart: FC<CustomIconProps> = (props) => {
  if (props.variant === 'twoTone') return <CustomIcon as={BlackboardChartTwoTone} {...props} />
  return <CustomIcon as={BlackboardChartOutline} {...props} />
}

export default memo(BlackboardChart)
